export default __webpack_public_path__ + "static/media/right_sidebar_checkout.a98e7c15.svg";